import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

import {Id} from './Product.style';
import {PriceWholeWrapper} from './ListProduct-v2.style';

const Info = styled.div`
  position: relative;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.medium`
    margin-top: 0;
  `};
`;

export const Container = styled.div`
  position: relative;
  width: 35rem;
  max-width: 35rem;
  height: 23rem;
  max-height: 23rem;
  padding-bottom: 1rem;
  margin: 0.8rem;
  flex-direction: column;
  background-color: ${p => p.theme.tertiaryBgColor};
  display: flex;
  ${media.smaller`
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
  `};
`;

export const ListViewContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  min-height: 15rem;
  ${media.small`
    min-height: 16rem;
  `}
`;

export const Price = styled.div`
  display: flex;
  flex-direction: column;
  color: ${p =>
    p.$isOffer
      ? p.theme.tertiaryColor
      : p.$isFirstOffer
      ? p.theme.primaryColor
      : p.theme.tertiaryTextColor};
  font-size: 1.4rem;
  align-items: baseline;
  ${media.small`
    flex-direction: row;
    font-size: 1.2rem;
    height: 1.2rem;
  `};
  ${media.smaller`
    width: auto;
  `};
`;
export const Small = styled.span`
  font-size: 0.9rem;
  line-height: 1rem;
  text-transform: uppercase;
  ${media.small`
    font-size: 1rem;
  `};
`;

export const SmallMatch = styled.span`
  font-size: 0.9rem;
  text-transform: uppercase;
  line-height: 1rem;
  padding-top: 0.3rem;
  ${media.small`
    font-size: 0.8rem;
    padding-right: 0.1rem;
  `};
`;

export const HideOnMobile = styled.span`
  ${media.small`
    display: none;
  `};
`;
export const Larger = styled.span`
  font-size: 1.5rem;
  ${media.small`
    font-size: 1.4rem;
  `};
`;

export const Content = styled.div`
  flex-grow: 1;
  padding: 0 1rem 0 0;
  text-align: center;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${media.small`
    justify-content: flex-start;
    margin-top: -0.1rem;
    padding-left: 1rem;
  `};

  div[data-id='promotionSection'] {
    justify-content: flex-start;
  }
`;

export const Weight = styled.span`
  flex-grow: 1;
  font-size: 1rem;
  text-align: left;
  color: ${p =>
    p.$isOffer ? p.theme.tertiaryColor : p.theme.tertiaryTextColor};
  line-height: 1.8rem;
  padding-top: 0.4rem;
  min-width: 100%;
  ${media.small`
    margin-top: 0;
  `};
`;

export const PhotoWrapper = styled.div`
  position: relative;
  width: 14rem;
  height: 14rem;
  text-align: center;
  cursor: pointer;
  ${media.smallest`
    display: flex;
    align-items: center;
  `};

  img {
    width: 12rem;
    height: 12rem;
    min-height: 12rem;
    min-width: 12rem;
    padding: 1rem;
    z-index: 1;
    ${media.small`
      width: 15rem;
      height: 15rem;
      min-width: 15rem;
      min-height: 15rem;
      max-height: 15rem;
    `};
    ${media.smallest`
      margin-left: 0;
    `};
  }
`;

export const ListViewInfo = styled(Info)`
  text-align: left;
`;

export const NameWrapper = styled.div`
  width: 100%;
  padding-bottom: 0.4rem;
  ${media.small`
    padding: 0;
  `};
`;
export const Name = styled.h3`
  display: block;
  font-size: 1.3rem;
  font-weight: normal;
  margin: 0;
  text-overflow: ellipsis;
  min-height: 3rem;
  max-height: 3rem;
  text-align: left;
  color: ${p => p.theme.primaryColor};
  cursor: pointer;
  overflow: hidden;
  ${media.medium`
    font-size: 1.2rem;
    min-height: 3rem;
    max-height: 3rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `};
`;

export const ButtonStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-size: 1.4rem;
  padding: 0 1rem 1rem 1rem;
  ${media.small`
    padding-left: 15rem;
    padding-right: 1rem;
    flex-grow: 1;
    max-width: 100%;
    a {
      width: 100%;
    }
  `};
  ${media.smaller`
    font-size: 1.2rem;
  `};
`;

export const Details = styled(Content)`
  padding: 0;
  width: 40%;
  flex-direction: column;
  text-align: center;
  justify-content: flex-end;
  ${media.small`
    width: 60%;
  `};
  ${media.smallest`
    width: 75%;
  `};
`;

export const PriceWrapper = styled.div`
  width: 100%;
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-bottom: 0.5rem;
  min-height: 4.5rem;
  ${media.small`
    padding: 0.5rem 0;
    line-height: 1.4rem;
    min-height: auto;
  `};
  ${media.smaller`
    padding: ${p => (p.$extraPadding ? '0.5rem 0 1rem' : '0.5rem 0')};
  `};
`;

export const Description = styled.span`
  display: block;
  font-size: 1.3rem;
  color: ${p => p.theme.textColor};
  line-height: 2rem;
  max-height: 4rem;
  height: 4rem;
  width: 100%;
  max-width: 100%;
  word-wrap: break-word;
  text-overflow: ellipsis;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  ${media.medium`
    font-size: 1.2rem;
    line-height: 1.6rem;
    margin-top: 0;
  `};
  ${media.small`
    line-height: 1.2rem;
  `};
  ${media.smaller`
    display: none;
  `};
`;

export const PromoWrapper = styled.div`
  text-align: center;
  width: 100%;
  height: 2rem;
  min-height: 2rem;
  max-height: 2rem;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.smaller`
    height: 1.6rem;
    flex-direction: column;
    min-height: 2.6rem;
    max-height: 2.6rem;
  `};
  ${media.smallest`
    align-items: flex-start;
    flex-direction: column;
    height: 2.2rem;
    min-height: 2.2rem;
    max-height: 2.2rem;
  `};
`;

export const SubWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
`;

export const TagsWrapper = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  bottom: -1rem;
  ${media.small`
    position: relative;
  `};
`;

export const ListId = styled(Id)`
  font-size: 1.4rem;
  margin-top: 0.5rem;
  ${media.small`
    max-width: 10rem;
  `}
  ${media.smaller`
    padding-left: 0;
  `}
`;

export const PriceUnavailable = styled.div`
  height: 6.5rem;
  display: flex;
  align-items: center;
`;

export const ExtraPromo = styled.div`
  color: ${p => p.theme.tertiaryColor};
  font-size: 1.6rem;
  width: 100%;
  text-align: left;
  text-transform: uppercase;
  height: 3.2rem;
  ${media.small`
   display: none;
  `};
`;

export const SmallExtraPromo = styled(ExtraPromo)`
  font-size: 1.4rem;
  ${media.medium`
   font-size: 1.3rem;
  `};
`;

export const SmallPriceWholeWrapper = styled(PriceWholeWrapper)`
  margin-top: ${p => (p.$hasNoOffers ? '3.3rem' : 0)};
`;

export const ListPriceWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  min-height: 1.8rem;
  line-height: 1.8rem;
  ${media.small`
    justify-content: flex-end;
    margin-bottom: ${p => (p.$extraBottom ? '0.5rem' : 0)};
  `};
`;

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PriceBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;
